module.exports = __webpack_public_path__ + "static/slide1-986af3aecc05077f4f71adb346ea5f83.png";